"use client";
import AnimatedButton from "@/commonComponents/animated-button";
import {
  arrowImageTransition,
  formStagger,
  formStaggerChildrenRight,
} from "@/commonComponents/animations";
import {
  MotionStack,
  MotionTypography,
} from "@/commonComponents/motion-components";
import SectionWrapper from "@/commonComponents/section-wrapper";
import { Stack } from "@mui/material";
import ArrowImage from "@/commonComponents/arrow-image";
import { StaticImageData } from "next/image";

export type OurInitiativesProps = {
  data: {
    image: StaticImageData | string;
    title: string;
    description: string;
    button: string;
    href: string;
  };
};

const OurInitiatives = (props: OurInitiativesProps) => {
  const { title, description, image, button, href } = props.data;
  return (
    <SectionWrapper
      SectionProps={{
        sx: {
          background: (theme) => theme.palette.gradient.lightToDark,
        },
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={"center"}
        justifyContent={"center"}
        rowGap={3}
        columnGap={{ md: 10, lg: 18 }}
      >
        <ArrowImage
          src={image}
          alt=""
          width={230}
          height={267}
          sx={{ minWidth: 230 }}
          ContainerProps={{ ...arrowImageTransition }}
        />
        <MotionStack
          direction={"column"}
          width={1}
          maxWidth={532}
          variants={formStagger}
          initial="initial"
          whileInView={"animate"}
          viewport={{ once: true }}
          rowGap={2}
        >
          <MotionTypography variant="h3" variants={formStaggerChildrenRight}>
            {title}
          </MotionTypography>
          <MotionTypography
            variant="body1"
            variants={formStaggerChildrenRight}
            mb={3}
          >
            {description}
          </MotionTypography>
          <AnimatedButton
            href={href}
            rotation="anticlockwise"
            variant={"contained"}
            color={"secondary"}
            animationDelay={2000}
            variants={formStaggerChildrenRight}
          >
            {button}
          </AnimatedButton>
        </MotionStack>
      </Stack>
    </SectionWrapper>
  );
};

export default OurInitiatives;
